/** Candidate colors for categorical map objects, independent of UI state.
 * Keep these named entries stable when extending the palette. Color selection
 * happens during design; rendering never generates colors from array positions.
 * Density ramps and interaction/status colors have separate semantics.
 */
export const MapObjectColors = {
  copper: '#E0A63B',
  olive: '#81B342',
  lake: '#167DA7',
  mulberry: '#B2509A',
  seaPine: '#21BC9B',
  heather: '#917DDD',
  slate: '#489DDA',
  rose: '#ED82AB',
  deepSea: '#365E78',
  indigo: '#5967AC',
  apricot: '#D98A5C',
  citron: '#B8C45A',
} as const;

/** Extra category colors; pair with labels or line styles when colors are close. */
export const MapObjectExtendedColors = {
  paleJade: '#85C7B8',
  paleLilac: '#B5A5D8',
  paleApricot: '#E9BB7E',
  paleLime: '#C5D58B',
} as const;

/** Twelve primary colors for automatic default assignment. */
export const MapObjectPalette: readonly string[] = Object.values(MapObjectColors);

export const MapObjectExtendedPalette: readonly string[] = Object.values(MapObjectExtendedColors);
export const MapObjectAvailablePalette: readonly string[] = [
  ...MapObjectPalette, ...MapObjectExtendedPalette,
];

/** Ordinary Area outlines share one opaque color; fills retain category colors. */
export const MapAreaBoundaryColor = '#617887';

/** Stable business assignments shared by map features, counts and legends. */
export const MapFeatureColors = {
  leads: MapObjectColors.copper,
  customers: MapObjectColors.olive,
  territories: MapObjectColors.seaPine,
  salesRoutes: MapObjectColors.lake,
  prospects: MapObjectColors.mulberry,
} as const;
